/**
 * 根据配置写入全局样式变量
 * @param theme 主题
 */
export const setPropertyWithTheme = (theme = 'light') => {
  // 通过读取config注入变量
  const config = process.config as { [key: string]: any }
  // console.log('=========config===========================')
  // console.log(config)
  // console.log('====================================')
  if (theme === 'dark') {
    // 暗黑模式处理
  } else {
    // 将配置注入到 CSS 变量
    document.documentElement.style.setProperty('--nsh5-dot-swap', config.style.dot.swap) // 换电站小点和图例
    document.documentElement.style.setProperty('--nsh5-dot-charge', config.style.dot.charge) // 充电站小点和图例
    document.documentElement.style.setProperty('--nsh5-dot-third', config.style.dot.third) // 三方桩小点和图例
    document.documentElement.style.setProperty(
      '--nsh5-swap-blink-stage1',
      config.style.swap_blink.stage1
    ) // 首页实时换电闪烁 状态1
    document.documentElement.style.setProperty(
      '--nsh5-swap-blink-stage2',
      config.style.swap_blink.stage2
    ) // 首页实时换电闪烁 状态2
  }
}
